<template>
  <ZtLink class="teaser is-default is-vertical" :to="url">
    <div class="teaser-media">
      <slot name="media">
        <div
          v-blokkli-droppable:[editableConfig?.image]
          class="image aspect-4/3"
        >
          <MediaImage v-bind="media" responsive-style="column_fifth" />
        </div>
      </slot>
    </div>
    <h2
      v-blokkli-editable:[editableConfig?.title]
      class="title is-6 mt-tiny"
      v-html="title"
    />
    <div
      v-blokkli-editable:[editableConfig?.tagline]
      class="subtitle is-7 mb-0"
      v-html="tagline"
    />
    <slot />
  </ZtLink>
</template>

<script lang="ts" setup>
import type { TeaserProps } from './types'

defineProps<TeaserProps>()
</script>
